import { isTenantAdminUser } from '@/util/adminRole';
import useAuth from '@/hooks/useAuth';

// V2 Order Flow is enabled for every tenant admin and every customer admin.
// The earlier per-client gate (created-at cutover plus an allowlist) is gone:
// all clients use V2. Other admin kinds (e.g. helpdesk) stay off, since they
// cannot create orders at all (see `create-new-order` in routes/roles.json).
//
// The dashboard still shows the V1 entry below 1024px (`useV2Entry`), because
// the V2 wizard is not built for narrow viewports.
const useOrderFlowV2Enabled = (): boolean => {
  const { currentAdmin, isCurrentCustomerAdmin } = useAuth();
  if (!currentAdmin) return false;
  if (isTenantAdminUser(currentAdmin)) return true;
  return isCurrentCustomerAdmin(currentAdmin);
};

export default useOrderFlowV2Enabled;
